import PriceRange from "@Shared/Entities/Hardware/PriceRange";
import { UPDATE_RANGE } from "@Store/Actions/Hardware/priceRange";
export default (state = new PriceRange({ low: 150, high: 700 }), { type, data }) => {
    switch (type) {
        case UPDATE_RANGE:
            return data;
    }
    return state;
};
